// flow weak

import React, {
    PureComponent
  }                             from 'react';
  import PropTypes              from 'prop-types';
  import AnimatedView           from '../../../../components';
  import styles                 from './style'
  import {
    defaultOptions,
    checkStatus,
    parseJSON,
    getLocationOrigin
  }                     from '../../../../services/fetchTools';
  import { withRouter } from 'react-router';
  import DatePicker from 'react-datepicker';
  import moment from 'moment';
  import styled from 'styled-components'
  import FlatButton from 'material-ui/FlatButton';
  import Dialog from 'material-ui/Dialog'
  import { Spinner } from 'react-activity';
  import 'react-activity/dist/react-activity.css';
  
  class Rental extends PureComponent {
    static propTypes = {
      actions: PropTypes.shape({
        enterPage: PropTypes.func,
        leavePage: PropTypes.func,
      })
    };
  
    constructor(props) {
      super(props);
      this.state = {
        revenue_response:[],
        show_dialog:false,
        show_court_dialog:false,
        court_rental_response:{},
        selected_data:{},
        activity_tracker_id: '',
        activity_state:true
      };
      this.onClick = this.onClick.bind(this);
      this.handleconfirmClick = this.handleconfirmClick.bind(this);
      this.onRentalClick = this.onRentalClick.bind(this);
  
    }
  
  
    componentDidMount() {
        this.get_rental_monthly_revenue()
    }

    onClick(res){
        console.log('onClick')
        this.setState({show_dialog:true})
        this.setState({selected_data:res})
        this.setState({activity_tracker_id:res.court_check_tracker_id})
        this.getCourtRentalDetails(res.venue_id)
    }

    onRentalClick(res){
        this.setState({selected_data:res})
        this.setState({show_court_dialog:true})
        this.setState({activity_tracker_id:res.court_rental_tracker_id})
        this.getCourtRentalDetails(res.venue_id)
    }

    getCourtRentalDetails(venue_id){
        const url = `${getLocationOrigin()}/cm/get_venue_court_booking_detail/?venue_id=${venue_id}`;
        const options = {...defaultOptions};

        return fetch(url, options)
        .then(checkStatus)
        .then(parseJSON)
        .then(data => {
            this.setState({court_rental_response:data});
        }).catch(error => error);
    }
  
    get_rental_monthly_revenue(){
        const url = `${getLocationOrigin()}/cm/get_rental_monthly_revenue`;
        const options = {...defaultOptions};

        return fetch(url, options)
        .then(checkStatus)
        .then(parseJSON)
        .then(data => {
            this.setState({revenue_response:data.result,activity_state:false});
        }).catch(error => error);
    }

    handleconfirmClick(){
        this.confirmActivity()
        this.setState({show_dialog:false,show_court_dialog:false})
    }

    confirmActivity(){
        const url = `${getLocationOrigin()}/cm/confirm_activity_tracker/`;
        const options = {...defaultOptions};
        options['method'] = 'post';
        options['headers'] = {'content-type': 'application/json'}
        options['body'] = JSON.stringify({
                            'activity_tracker_id': this.state.activity_tracker_id,
                            'object_id': this.state.selected_data.prev_day_rental_id,
                            });
        
        return fetch(url, options)
            .then(checkStatus)
            .then(parseJSON)
            .then(data => {
                alert(data.message)
            });
    }

    
  
    render() {
        const action = [
            <FlatButton
              label="CONFIRM"
              primary={true}
              onClick={this.handleconfirmClick}
            />,
          ];

        const rental_action = [
            <FlatButton
              label="CONFIRM"
              primary={true}
              onClick={this.handleconfirmClick}
            />,
        ];

        const StyledContainer = styled.div`
        background: white;
        box-shadow: 0 1px 4px rgba(0,0,0,.15);
        padding: 5px;
        margin: 10px;
        `

        const Head = styled.h4`
        padding-top: 10px;
        color: black;
        font-weight: 300;
        text-align: center;
        font-size:28px;
        @media (max-width: 500px) {
            font-size: 1rem;
        }` 

        const Title = styled.h4`
        color: black;
        font-weight: 300;
        text-align: center;
        font-size:14px;
        @media (max-width: 500px) {
            font-size: 1rem;
        }` 

        const Button = styled.h2`
        color: white;
        font-weight: 300;
        margin: 10px;
        padding: 5px;
        background: grey;
        text-align: center;
        cursor:pointer;
        @media (max-width: 500px) {
            font-size: 0.8rem;
        }
        `

        const StyledRoot = styled.div`
        padding: 0px;
        display: flex;
        `
      return(
        <div style={styles.container}>
            {this.state.activity_state ? 
            <div style={{position:'absolute',marginTop:'30%',marginLeft:'40%'}}>
                <Spinner size="50" />
            </div>
            :
            this.state.revenue_response && this.state.revenue_response.length > 0 &&
                this.state.revenue_response.map((res, index)=>{{
                    return(
                    <div style={{flexDirection:'row'}}>    
                        <div style={{fontSize:'26px',paddingLeft:'10px',fontWeight:'bold'}}>{res.venue}</div>
                        <div style={{marginTop:'10px',display:'flex'}}>
                            <StyledRoot className='col-md-12'>
                                <StyledContainer className='col-md-4'>
                                    <Head>{res.rental_revenue != null ? res.rental_revenue : '-'} / {res.rental_target != null ? res.rental_target : '-'}</Head>
                                    <Title>Total Court Rental in </Title>
                                </StyledContainer>

                                <StyledContainer className='col-md-4'>
                                <Head>- / -</Head>
                                    <Title>Total Equipment Rental</Title>
                                </StyledContainer>

                                <StyledContainer className='col-md-4'>
                                    <Head>- / -</Head>
                                    <Title>Total F&B Rental</Title>
                                </StyledContainer>

                                <StyledContainer className='col-md-4'>
                                    <Head>{res.service_revenue != null ? res.service_revenue : '-'} / {res.service_target != null ? res.service_target : '-'}</Head>
                                    <Title>Total Service Rental</Title>
                                </StyledContainer>
                            </StyledRoot>
                        </div>
                    
                        <div style={{marginTop:'10px'}}>
                            <StyledRoot className='col-md-12'>
                                {res.court_rental_tracker &&
                                    <StyledContainer className='col-md-4'>
                                        <Head>{res.prev_day_rental_revenue != null ? res.prev_day_rental_revenue : '-'} / {res.prev_day_rental_target != null ? res.prev_day_rental_target : '-' }</Head>
                                        <Title>Prev day Court Rental</Title>
                                        <Button style={{backgroundColor:res.court_rental_tracker_marked ? '#4daa0b' : 'red'}} onClick={()=>{this.onRentalClick(res)}}>{res.court_rental_tracker_marked ? "Checked" : "Check"}</Button>
                                    </StyledContainer>
                                }

                                {res.equipment_rental_tracker &&
                                    <StyledContainer className='col-md-4'>
                                        <Head>{res.prev_day_equipment_revenue != null ? res.prev_day_equipment_revenue : '-'} / {res.prev_day_equipment_target != null ? res.prev_day_equipment_target : '-'}</Head>
                                        <Title>Prev day Equipment Rental</Title>
                                        {/* <Button>{res.equipment_rental_tracker_marked ? "Checked":"Check"}</Button> */}
                                    </StyledContainer>
                                }

                                {res.f_and_b_rental_tracker &&
                                    <StyledContainer className='col-md-4'>
                                        <Head>{res.prev_day_f_and_b_revenue != null ? res.prev_day_f_and_b_revenue : '-'} / {res.prev_day_f_and_b_target != null ? res.prev_day_f_and_b_target : '-'}</Head>
                                        <Title>Prev day F&B Rental</Title>
                                        
                                        {/* <Button>{res.f_and_b_rental_tracker_marked ? "Checked":"Check"}</Button> */}
                                    </StyledContainer>
                                }

                                {res.court_rental_tracker &&    
                                    <StyledContainer className='col-md-4'>
                                        <Head>{res.total_court_sold_yesterday != null ? res.total_court_sold_yesterday : '-'}/ {res.total_court_hours ? res.total_court_hours : '-'}</Head>
                                        <Title>Total Court hours sold yesterday</Title>
                                        <Button style={{backgroundColor:res.court_check_tracker_marked ? '#4daa0b' : 'red' }} onClick={()=>{this.onClick(res)}}>{res.court_check_tracker_marked ? "Checked" : "Check"}</Button>
                                    </StyledContainer>
                                }
                            </StyledRoot>
                        </div>
                    </div>
                    )
                }})
            }
            <div className="col-md-12">
                <Dialog
                    actions={action}
                    modal={false}
                    open={this.state.show_dialog}
                    onRequestClose={()=>{this.setState({show_dialog:false})}}
                    autoDetectWindowHeight={true}
                    autoScrollBodyContent={true}
                >
                    <div>
                        <div className="col-md-12" style={{flexDirection:'column'}}>
                        <div className="col-md-12">
                            <div style={{color: '#32B6A7',fontSize: '130%',textAlign:'center',borderBottom: '1px solid',}}>Court Rental</div>
                        </div> 
                            <div className="col-md-12" style={{fontSize:'20px',fontWeight:'400',fontColor:'black',paddingTop:'10px'}}>
                                Total Court Rental hours Sold - {this.state.court_rental_response.no_of_sold_slot} Hours
                            </div>
                            <div className="col-md-12" style={{fontSize:'20px',fontWeight:'400',fontColor:'black',paddingTop:'10px'}}>
                                Total Hours Booked through Playo - {this.state.court_rental_response.playo_booking} Hours
                            </div>
                            <div className="col-md-12" style={{fontSize:'20px',fontWeight:'400',fontColor:'black',paddingTop:'10px'}}>
                                Total Hours Booked through Website - {this.state.court_rental_response.web_booking} Hours
                            </div>
                            <div className="col-md-12" style={{fontSize:'20px',fontWeight:'400',fontColor:'black',paddingTop:'10px'}}>
                                Total Hours Booked through App - {this.state.court_rental_response.app_booking} Hours
                            </div>
                            <div className="col-md-12" style={{fontSize:'20px',fontWeight:'400',fontColor:'black',paddingTop:'10px'}}>
                                Total Hours Booked by Admin - {this.state.court_rental_response.admin_booking} Hours
                            </div>
                        </div>
                    </div> 
                </Dialog>
            </div>
            <div className="col-md-12">
                <Dialog
                    actions={rental_action}
                    modal={false}
                    open={this.state.show_court_dialog}
                    onRequestClose={()=>{this.setState({show_court_dialog:false})}}
                    autoDetectWindowHeight={true}
                    autoScrollBodyContent={true}
                >
                    <div>
                        <div className="col-md-12" style={{flexDirection:'column'}}>
                            <div className="col-md-12">
                                <div style={{color: '#32B6A7',fontSize: '130%',textAlign:'center',borderBottom: '1px solid',}}>Court Rental</div>
                            </div>
                            <div className="col-md-12" style={{fontSize:'20px',fontWeight:'400',fontColor:'black',paddingTop:'10px'}}>
                                Total Court Rental - {this.state.court_rental_response.total_booking_amount} ({this.state.court_rental_response.no_of_sold_slot} bookings)
                            </div>
                            <div className="col-md-12" style={{fontSize:'20px',fontWeight:'400',fontColor:'black',paddingTop:'10px'}}>
                                Total revenue from Playo - {this.state.court_rental_response.playo_booking_amount} ({this.state.court_rental_response.playo_booking} bookings)
                            </div>
                            <div className="col-md-12" style={{fontSize:'20px',fontWeight:'400',fontColor:'black',paddingTop:'10px'}}>
                                Total revenue from Website - {this.state.court_rental_response.web_booking_amount} ({this.state.court_rental_response.web_booking} bookings)
                            </div>
                            <div className="col-md-12" style={{fontSize:'20px',fontWeight:'400',fontColor:'black',paddingTop:'10px'}}>
                                Total revenue from App - {this.state.court_rental_response.app_booking_amount} ({this.state.court_rental_response.app_booking} bookings)
                            </div>
                            <div className="col-md-12" style={{fontSize:'20px',fontWeight:'400',fontColor:'black',paddingTop:'10px'}}>
                                Total revenue from Admin - {this.state.court_rental_response.admin_booking_amount} ({this.state.court_rental_response.admin_booking} bookings)
                            </div>
                        </div>
                    </div> 
                </Dialog>
            </div>
        </div>
      );
    }
  }
  
  export default Rental;
  


// WEBPACK FOOTER //
// ./src/app/views/partner/crud/rental/index.js